<template>
  <div class="removeDust_historicalTrend _boxBg_dark_big absolute_center intro_detail">
    <div class="selfClose_btn" @click="close"></div>
    <div class="intro_detail_content">{{detail}}</div>
  </div>
</template>

<script>
export default {
  props: ['detail'],
  mounted() {
    console.log(this.detail)
  },
  methods: {
    close() {
      this.$popup.close(this)
    }
  }
}
</script>

<style lang="scss" scoped>
.intro_detail {
  width: 800px;
  padding: 80px 20px;
  font-size: 26px;
  line-height: 50px;
  .selfClose_btn {
    right: -92px;
  }
  .intro_detail_content {
    text-indent: 24px;
    height: 100%;
    overflow-y: scroll;
  }
}
</style>